module.exports = __webpack_public_path__ + "media/images/tmp/slide2-e9082f29e062b08076f449547e4e71fd.jpg";